<button
  mat-icon-button
  (click)="onClick()"
  [matTooltip]="'Filter'"
  [ngClass]="{'ops-selectable-secondary': active}"
  class="report-button"
>
  <mat-icon>tune</mat-icon>

  <div class="badge-number"
       *ngIf="!active && appliedFiltersCount > 0"
  >
    <span>{{ appliedFiltersCount }}</span>
  </div>
</button>
